//====================================================
//  Function: Graph
//====================================================
function fn_components_graph(){
	if ($( '.js-select-graph' ).length){
		$( '.js-select-graph' ).on('click' , function(e){
			if (!$(this).hasClass(class_active)){
				$('.js-select-graph').removeClass( class_active );
				$(this).addClass( class_active );
			}
		});
	}
}
